import { useContext } from 'react';
import { UserContexts } from '../../Context/UserContexts';
import TechList from '../TechList';
import { MainDash } from './styles';

function ConteinerList() {
    const { techs, handleOpen } = useContext(UserContexts)
  return (
    <MainDash>
        <div className='headerListTechs'>
            <h3>Tecnologias</h3>
            <button onClick={()=>handleOpen()}>+</button>
        </div>
        {techs? 
            <TechList></TechList>:<p>Ainda nao tem techs</p>
        }
  </MainDash>
  );
}

export default ConteinerList;